import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { getProductDetail } from "../../../modules/reducers/productSearch/productDetail";
import { productDetailApi } from "./../api/product/productDetailApi";
import { setDestination } from "../../../modules/reducers/destination/destination";

const useProductDetail = () => {
  const productDetail = useSelector((state) => state.productDetail.product);

  const location = useLocation();
  const dispatch = useDispatch();

  const { itemId, storeId, brandCd } = location.state || {};

  useEffect(() => {
    dispatch(
      setDestination({
        from: location.pathname,
        to: null,
      })
    );
  }, []);

  useEffect(() => {
    if (storeId !== null && brandCd !== null) {
      dispatch(getProductDetail(productDetailApi(itemId, storeId, brandCd)));
    }
  }, [itemId, storeId, brandCd]);
  return { productDetail };
};

export default useProductDetail;
